import { Box } from "@mui/material";

import CarLineMobIcon from "@/assets/icons/hero/line-mob.svg?react";
import CarLineDeskIcon from "@/assets/icons/hero/line-desk.svg?react";
import CarMobIcon from "@/assets/icons/hero/car.svg?react";
import TruckIcon from "@/assets/icons/hero/car-truck.svg?react";
import useResponsive from "@/hooks/useResponsive";
import { carIconStyles, carIconWrapperStyles, lineIconStyles } from "./styles";

const CarIcon = () => {
  const isMobile = useResponsive("down", "md");

  return (
    <Box sx={carIconWrapperStyles}>
      <Box sx={lineIconStyles}>
        {isMobile ? <CarLineMobIcon width={"100%"} /> : <CarLineDeskIcon />}
      </Box>
      <Box sx={carIconStyles}>
        {isMobile ? (
          <TruckIcon width={isMobile ? 30 : 96} height={isMobile ? 30 : 95} />
        ) : (
          <CarMobIcon width={isMobile ? 30 : 96} height={isMobile ? 30 : 96} />
        )}
      </Box>
    </Box>
  );
};

export default CarIcon;
